import Model from './Model.js';
import EmbedPageSettings from './EmbedPageSettings';
import MailIntegration from './MailIntegration';
import MembershipIntegration from './MembershipIntegration';
import otherIntegration from './OtherIntegration';
import WebhookIntegration from './WebhookIntegration';
import WatchedUntilTime from './WatchedUntilTime';

export default class Video extends Model {
  resource() {
    return 'videos';
  }

  /**
   * now we are getting this from api side 
   * so commenting this out
   */
  // get thumbnail() {
  //   if (
  //     this.settings.splashImg &&
  //     typeof this.settings.splashImg !== 'undefined' &&
  //     this.settings.splashImg !== ''
  //   ) {
  //     return this.settings.splashImg;
  //   }
  //   return this.thumbnail_url;
  // }

  get video_embed() {
    if ((this.video_source && this.video_source != '') || (typeof this.is_local !== 'undefined' && this.is_local === 1 && this.video_stream_source != '' && this.video_stream_source !== null)) {
      let file;
      if(process.env.NODE_ENV === 'production'){ 
        file = 'app';
      }
      else {
        file = 'app-test';
      }
      return `<link href="https://widget.groovevideo.com/widget/${file}.css" rel="stylesheet"><groovevideo-widget id="${this.id}" permalink="${this.permalinks}"></groovevideo-widget><script src="https://widget.groovevideo.com/widget/${file}.js"></script>`;
    }
    return '';
  }

  get hostedPageLink() {
    if ((
      this.video_source &&
      this.video_source !== '' &&
      this.hosted_page_settings
    ) || (typeof this.is_local !== 'undefined' && this.is_local === 1 && this.video_stream_source != '' && this.video_stream_source !== null)) {
      const baseUrl =
        process.env.NODE_ENV === 'development'
          ? `${window.config.grooveappsurl}`
          : `${window.config.grooveappsurl}/groovevideo`;
      return `${baseUrl}/videopage/${this.id}/${this.hosted_page_settings.permalink}`;
    }
    return '';
  }

  embedPageSettings() {
    return this.hasMany(EmbedPageSettings);
  }
  
  mailIntegration() {
    return this.hasMany(MailIntegration);
  }

  membershipIntegration() {
    return this.hasMany(MembershipIntegration);
  }

  webhookIntegration() {
    return this.hasMany(WebhookIntegration);
  }

  otherIntegration() {
    return this.hasMany(otherIntegration);
  }

  watchedUntilEvent() {
    return this.hasMany(WatchedUntilTime);
  }

}
